import React from "react";
import pick from "lodash/pick";
import PropTypes from "prop-types";
import { Flex } from "grid-styled";
import Text, { P } from "../Text";
import Address from "../Address";
import { ContactFields } from "../forms";
import { reduxForm } from "redux-form";
import { contactDisplayName } from "../../utils/helpers";
import { Panel, PanelHeader, PanelBody } from "../Panel";
import Button from "../Button";

const ContactForm = reduxForm({
  form: "contactEdit"
})(({ handleSubmit, onCancel }) => {
  return (
    <form onSubmit={handleSubmit}>
      <ContactFields />
      <Flex justify="flex-end">
        <Button type="button" onClick={onCancel} style={{ marginRight: 4 }}>
          Cancel
        </Button>
        <Button type="submit" variant="primary">
          Save
        </Button>
      </Flex>
    </form>
  );
});

class ContactCard extends React.Component {
  static propTypes = {
    contact: PropTypes.object.isRequired,
    onSave: PropTypes.func.isRequired,
    sendToChatmeter: PropTypes.bool
  };

  state = {
    editing: false,
    changingChatmeter: false
  };

  handleToggleFeedback = () => {
    // TODO: Add some sort of flash message
    this.setState({ changingChatmeter: true });
    return this.props
      .onSave({ sendToChatmeter: !this.props.sendToChatmeter })
      .then(() => this.setState({ changingChatmeter: false }));
  };

  save = values => {
    // TODO: Add some sort of flash message
    return this.props
      .onSave({
        contact: { ...values }
      })
      .then(this.toggleEdit);
  };

  toggleEdit = () => {
    this.setState({ editing: !this.state.editing });
  };

  renderContact() {
    const { contact } = this.props;
    return (
      <div>
        <P style={{ marginBottom: 0 }}>
          <b>{contactDisplayName(contact)}</b>
        </P>
        <Address address={contact.address} style={{ marginTop: 0 }} />
        <P>
          <b>Email:</b>
          <br />
          {contact.email}
        </P>
        <P>
          <b>Phone:</b>
          <br />
          {contact.phone}
        </P>
        <Button
          type="button"
          variant={this.props.sendToChatmeter ? "danger" : undefined}
          disabled={this.state.changingChatmeter}
          onClick={this.handleToggleFeedback}
        >
          {this.state.changingChatmeter
            ? this.props.sendToChatmeter ? "Removing from" : "Sending to"
            : this.props.sendToChatmeter ? "Remove from" : "Send to"}{" "}
          Reputation Loop
        </Button>
      </div>
    );
  }

  renderForm() {
    const initialValues = pick(
      this.props.contact,
      "id",
      "firstName",
      "lastName",
      "otherFirstName",
      "otherLastName",
      "email",
      "phone",
      "address.id",
      "address.streetAddress",
      "address.aptNumber",
      "address.city",
      "address.state",
      "address.zipCode",
      "address.country"
    );
    return (
      <ContactForm
        initialValues={initialValues}
        onSubmit={this.save}
        onCancel={this.toggleEdit}
      />
    );
  }

  render() {
    const { contact, onSave, sendToChatmeter, ...otherProps } = this.props;
    const { editing } = this.state;
    return (
      <Panel {...otherProps}>
        <PanelHeader>
          <span>Contact</span>
          <Button
            onClick={this.toggleEdit}
            style={{ marginLeft: "auto" }}
            size="sm"
            disabled={editing}
          >
            {editing ? "Editing" : "Edit"}
          </Button>
        </PanelHeader>
        <PanelBody>
          {editing ? this.renderForm() : this.renderContact()}
        </PanelBody>
      </Panel>
    );
  }
}

export default ContactCard;



// WEBPACK FOOTER //
// ./src/components/job/ContactCard.js